import React from "react";
import { useTranslation } from "react-i18next";
import ContactComponent from "../minicomponents/ContactComponent";

function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="text-center pt-24 md:pt-28 pb-16 px-4 md:px-8 bg-gray-900 text-white min-h-screen">
      <h1 className="alt-font text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-4 text-white">
        {t("contact.title", "Contact")}
      </h1>
      <p className="mt-4 mb-8 text-lg text-gray-300 max-w-xl mx-auto">
        {t("contact.subtitle", "Have questions or want to get in touch?")}
      </p>

      <ContactComponent />
    </div>
  );
}

export default ContactPage;
